// extracted by mini-css-extract-plugin
export default {"fieldGroupDelimiter":"Delimiter_fieldGroupDelimiter__TZWqb"};